'use strict';

const base = require('./base');
const initPopOver = require('../components/initPopOver');
const initSwiperSlider = require('../components/swiperSlider').initSwiperSlider;
const { showToastMessage } = require('../components/toast');
const { variantImgHover } = require('../product/variantImgHover');

/**
 * Enable/disable UI elements
 * @param {boolean} enableOrDisable - true or false
 */
function updateAddToCartEnableDisableOtherElements(enableOrDisable) {
    $('button.add-to-cart-global').attr('disabled', enableOrDisable);
}

/**
 * This function retrieves another page of content to display in the content search grid
 * @param {JQuery} configurableProductSwiperElement - swiper object
 * @return {undefined}
 */

function lazyLoadProductSlides($element, configurableProductSwiperElement, slidesContent) {
    if (!$element || !configurableProductSwiperElement || !slidesContent) {
        return;
    }

    $element.remove();
    const container = document.createElement('div');
    container.innerHTML = slidesContent;
    const swiperSliderElements = container.querySelectorAll('.swiper-slide');

    const slides = [];
    swiperSliderElements.forEach((slide) => {
        slides.push(slide.outerHTML.toString());
    });

    const moreLink = container.querySelector('.js-show-more-swiper-url');

    configurableProductSwiperElement.appendSlide(slides);

    if (moreLink) {
        configurableProductSwiperElement.el.appendChild(moreLink);
    }

    configurableProductSwiperElement.update();
    initPopOver();
}

/**
 * This function retrieves another page of content to display in the content search grid
 * @param {JQuery} $element - the jquery element that has the click event attached
 * @param {JQuery} $target - the jquery element that will receive the response
 * @param {JQuery} isSlider - boolean to check whether slider
 * @param {JQuery} configurableProductSwiperElement - swiper object
 * @return {undefined}
 */
function getMoreContent($element, $target, isSlider, configurableProductSwiperElement) {
    const showMoreUrl = $element.data('url');
    const selectedProductRadio = $element.closest('.js-configurator-section').find("input[type='radio']:checked");
    const selectedPid = selectedProductRadio?.data('pid');
    const selectedPidPrice = selectedProductRadio?.data('price');

    const url = new URL(`${window.location.origin}${showMoreUrl}`);
    url.searchParams.set('selectedPid', selectedPid);
    url.searchParams.set('selectedPidPrice', selectedPidPrice);

    if (!isSlider) {
        $target.find('.js-load-more-placeholder-wrapper').removeClass('d-none');
    }

    $.ajax({
        url: url.href,
        method: 'GET',
        success: function (response) {
            if (!isSlider) {
                $target.find('.js-load-more-placeholder-wrapper').remove();
                $target.append(response);
            } else {
                lazyLoadProductSlides($element, configurableProductSwiperElement, response);
            }
        },
        error: function () {
            $target.find('.js-load-more-placeholder-wrapper').removeClass('d-none');
        }
    });
}

function triggerLoadMoreOnSwiperSlider(swiperEle) {
    function waitForSwiperInstance() {
        return new Promise((resolve) => {
            const checkSwiper = () => {
                const configurableProductSwiperElement = swiperEle?.swiper;
                if (configurableProductSwiperElement) {
                    resolve(configurableProductSwiperElement);
                } else {
                    setTimeout(checkSwiper, 100);
                }
            };
            checkSwiper();
        });
    }

    waitForSwiperInstance().then((configurableProductSwiperElement) => {
        configurableProductSwiperElement.on('slideNextTransitionStart', () => {
            const slider = configurableProductSwiperElement.el;
            const moreLink = slider?.querySelector('.js-show-more-swiper-url');
            if (moreLink && slider) {
                getMoreContent($(moreLink), $(slider).closest('.section-content'), true, configurableProductSwiperElement);
            }
        });
    });
}

function updateProductPrice(currentDelta = 0) {
    const configSections = document.querySelector('.js-configurator-sections');
    const kosmElement = document.querySelector('#osm-pdp-placement');
    if (configSections) {
        const priceElement = document.querySelector('.prices-add-to-cart-actions .js-price .sales .value');
        const listPriceValueElement = document.querySelector('.prices-add-to-cart-actions .js-price .strike-through.list .value');
        const listPriceUnitElement = document.querySelector('.prices-add-to-cart-actions .js-price .strike-through.list .value .js-unit-price');
        const currentTotalPrice = parseFloat(configSections?.getAttribute('data-configuration-product-price'));

        const locale = configSections?.dataset.locale.replace('_', '-');
        const currencyCode = configSections?.dataset.currencyCode;

        let updatedPrice = 0;
        if (currentDelta >= 0) {
            updatedPrice = currentTotalPrice + Math.abs(currentDelta);
        } else {
            updatedPrice = currentTotalPrice - Math.abs(currentDelta);
        }

        if (priceElement) {
            priceElement.setAttribute('content', updatedPrice.toFixed(2));
            configSections.setAttribute('data-configuration-product-price', updatedPrice.toFixed(2));
            priceElement.innerHTML = Intl.NumberFormat(locale, {
                style: 'currency',
                currency: currencyCode
            }).format(updatedPrice);
        }

        if (listPriceValueElement && listPriceUnitElement) {
            const storedListPrice = parseFloat(configSections.getAttribute('data-configuration-product-list-price'));
            const currentListPrice = Number.isNaN(storedListPrice) ? parseFloat(listPriceValueElement.getAttribute('content')) : storedListPrice;
            if (!Number.isNaN(currentListPrice)) {
                const updatedListPrice = currentListPrice + currentDelta;
                listPriceValueElement.setAttribute('content', updatedListPrice.toFixed(2));
                configSections.setAttribute('data-configuration-product-list-price', updatedListPrice.toFixed(2));
                listPriceUnitElement.textContent = Intl.NumberFormat(locale, {
                    style: 'currency',
                    currency: currencyCode
                }).format(updatedListPrice);
            }
        }

        if (kosmElement) {
            kosmElement.setAttribute('data-purchase-amount', Math.round(updatedPrice * 100));
        }
    }
}

/**
 * Applies the server-side configurator sections price delta to the list price (Streichpreis) on page load.
 * Only runs when a configuratorConfig param was present, indicated by the data-configuration-list-price-delta attribute.
 *
 * @returns {void}
 */
function initConfiguratorListPrice() {
    const configSections = document.querySelector('.js-configurator-sections');
    if (!configSections) {
        return;
    }
    const listPriceValueElement = document.querySelector('.prices-add-to-cart-actions .js-price .strike-through.list .value');
    const listPriceUnitElement = document.querySelector('.prices-add-to-cart-actions .js-price .strike-through.list .value .js-unit-price');
    if (!listPriceValueElement || !listPriceUnitElement) {
        return;
    }
    const sectionsDelta = parseFloat(configSections.getAttribute('data-configuration-list-price-delta'));
    if (!sectionsDelta) {
        return;
    }
    const adjustedListPrice = parseFloat(listPriceValueElement.getAttribute('content')) + sectionsDelta;
    if (Number.isNaN(adjustedListPrice)) {
        return;
    }
    const locale = configSections.dataset.locale.replace('_', '-');
    const currencyCode = configSections.dataset.currencyCode;
    listPriceValueElement.setAttribute('content', adjustedListPrice.toFixed(2));
    configSections.setAttribute('data-configuration-product-list-price', adjustedListPrice.toFixed(2));
    listPriceUnitElement.textContent = Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currencyCode
    }).format(adjustedListPrice);
}

function setSelectedPcConfiguratorCases(currentSection, selectedCasesElement) {
    const casesElements = currentSection.find('.js-configurator-product');
    if (casesElements && selectedCasesElement) {
        casesElements.removeClass('configurator-product-selected');
        $(selectedCasesElement).addClass('configurator-product-selected');
    }
}

function updateDeltaLabels(productSelectorInputs, currentSelectedPrice) {
    const configSections = document.querySelector('.js-configurator-sections');
    const locale = configSections?.dataset.locale.replace('_', '-');
    const currencyCode = configSections?.dataset.currencyCode;
    const selectedLabel = configSections?.dataset.selectedLabel;

    productSelectorInputs.each(function () {
        const price = parseFloat($(this).data('price'));
        const deltaLabelElem = $(this).closest('.js-configurator-product-selector').find('.js-delta');
        const deltaPrice = price - currentSelectedPrice;
        $(this).attr('data-delta', deltaPrice.toFixed(2));
        $(this).attr('data-raw-delta', deltaPrice.toFixed(2));

        if (deltaPrice >= 0) {
            if ($(this).is(':checked')) {
                deltaLabelElem.html(selectedLabel);
            } else {
                deltaLabelElem.html('+' + Intl.NumberFormat(locale, {
                    style: 'currency',
                    currency: currencyCode
                }).format(Math.abs(deltaPrice)));
            }
        } else {
            deltaLabelElem.html('-' + Intl.NumberFormat(locale, {
                style: 'currency',
                currency: currencyCode
            }).format(Math.abs(deltaPrice)));
        }
    });
}

function getSavedConfigurationObj(savedConfiguration) {
    if (!savedConfiguration) {
        return {};
    }

    try {
        return JSON.parse(savedConfiguration);
    } catch (e) {
        console.error(e);
        return {};
    }
}

/**
 * Reads the live configurator configuration from the DOM and writes it onto
 * a URL's `configuratorConfig` query param, letting URLSearchParams handle the
 * encoding (avoids double-encoding).
 * @param {URL} url - The URL to modify in place.
 * @return {URL} The same URL instance, for chaining.
 */
function setConfiguratorConfigParam(url) {
    const config = getSavedConfigurationObj($('.js-configurator-sections').attr('data-configurator-config'));
    url.searchParams.set('configuratorConfig', JSON.stringify(config));
    return url;
}

function isConfiguratorNotBuyable() {
    const sectionsWrapper = document.querySelector('.js-availability-add-to-cart');
    const sectionPrice = document.querySelector('.js-configurator-sections');
    if (!sectionsWrapper) {
        return false;
    }

    const notBuyableValue = sectionsWrapper.getAttribute('data-notbuyable');
    const hasPriceError = sectionPrice?.getAttribute('data-configuration-product-price') === 'NaN';
    return notBuyableValue === 'true' || hasPriceError === true;
}

function getNotBuyableProducts(sections) {
    const products = [];

    sections.forEach(section => {
        const header = section.querySelector('.js-section-header');
        if (header?.dataset.notbuyable === 'true') {
            const selectedProduct = header.querySelector('.js-selected-product-name')?.innerHTML;
            const headerId = header.id;
            if (selectedProduct) {
                products.push({
                    headerId: headerId,
                    content: selectedProduct
                });
            }
        }
    });

    return products;
}

function disableAddToCartWithAlert(atcButton, feedbackWrapper, alertMessage, alertType, productList) {
    atcButton?.setAttribute('disabled', 'true');

    const productsNotBuyableAlertId = 'sectionProductsNotBuyable-alert';
    const productsNotBuyableWrapperClass = 'js-products-not-buyable';
    const labelReplace = feedbackWrapper.dataset.messageReplace;

    let productItemsHTML = '';

    if (Array.isArray(productList) && productList.length > 0) {
        productItemsHTML = productList.map(product => {
            return `
                <div class="d-flex gap-3 justify-content-between align-items-center">
                    <div class="flex-1 small fw-bold text-body-emphasis">
                        ${product.content}
                    </div>
                    <div class="flex-shrink-1">
                        <button class="js-btn-replace-section-product btn-reset text-decoration-underline text-body-emphasis small p-0" data-scroll-to="#${product.headerId}">
                            ${labelReplace}
                        </button>
                    </div>
                </div>
            `;
        }).join('');
    }

    let alert = feedbackWrapper.querySelector(`#${productsNotBuyableAlertId}`);

    if (!alert) {
        alert = document.createElement('div');
        alert.id = productsNotBuyableAlertId;
        alert.className = `alert ${alertType} my-sm-6`;
        alert.innerHTML = `
            <p class="mb-0">${alertMessage}</p>
            ${productItemsHTML ? `<div class="${productsNotBuyableWrapperClass} d-flex flex-column gap-3 mt-3">${productItemsHTML}</div>` : ''}
        `;
        feedbackWrapper.appendChild(alert);
    } else {
        alert.querySelector('p').innerHTML = alertMessage;

        const wrapper = alert.querySelector(`.${productsNotBuyableWrapperClass}`);
        if (wrapper && productItemsHTML) {
            wrapper.innerHTML = productItemsHTML;
        } else if (wrapper && !productItemsHTML) {
            wrapper.remove();
        } else if (!wrapper && productItemsHTML) {
            const newWrapper = document.createElement('div');
            newWrapper.className = `${productsNotBuyableWrapperClass} d-flex flex-column gap-3 mt-3`;
            newWrapper.innerHTML = productItemsHTML;
            alert.appendChild(newWrapper);
        }
    }
}

function enableAddToCartAndClearAlert(atcButton, feedbackWrapper) {
    atcButton?.removeAttribute('disabled');
    feedbackWrapper.innerHTML = '';
}

function handleSectionNotBuyable() {
    if (isConfiguratorNotBuyable()) {
        return;
    }

    const sections = document.querySelectorAll('.js-configurator-sections .js-configurator-section');
    if (!sections.length) {
        return;
    }
    const atcButton = document.querySelector('.prices-add-to-cart-actions .add-to-cart');
    const feedbackWrapper = document.querySelector('.js-configurator-product-feedback-element-wrapper');
    const alertMessage = feedbackWrapper.dataset.messageSectionNotBuyable;

    const notBuyableProducts = getNotBuyableProducts(sections);

    if (notBuyableProducts.length > 0) {
        disableAddToCartWithAlert(atcButton, feedbackWrapper, alertMessage, 'alert-warning', notBuyableProducts);
    } else {
        enableAddToCartAndClearAlert(atcButton, feedbackWrapper);
    }
}

function handleConfiguratorNotBuyable() {
    if (isConfiguratorNotBuyable()) {
        const atcButton = document.querySelector('.prices-add-to-cart-actions .add-to-cart');
        const feedbackWrapper = document.querySelector('.js-configurator-product-feedback-element-wrapper');
        if (!feedbackWrapper) {
            return;
        }
        const alertMessage = feedbackWrapper.dataset.messageConfiguratorNotBuyable;

        disableAddToCartWithAlert(atcButton, feedbackWrapper, alertMessage, 'alert-warning');
    }
}

initConfiguratorListPrice();

module.exports = {
    updateProductPrice: updateProductPrice,
    methods: {
        updateAddToCartEnableDisableOtherElements: updateAddToCartEnableDisableOtherElements
    },

    availability: base.availability,

    updateAttributesAndDetails: function () {
        $('body').on('product:statusUpdate', function (e, data) {
            var $productContainer = $('.product-detail[data-pid="' + data.id + '"]');

            $productContainer.find('.description-and-detail .product-attributes')
                .empty()
                .html(data.attributesHtml);

            if (data.shortDescription) {
                $productContainer.find('.description-and-detail .description')
                    .removeClass('hidden-xl-down');
                $productContainer.find('.description-and-detail .description .content')
                    .empty()
                    .html(data.shortDescription);
            } else {
                $productContainer.find('.description-and-detail .description')
                    .addClass('hidden-xl-down');
            }

            if (data.longDescription) {
                $productContainer.find('.description-and-detail .details')
                    .removeClass('hidden-xl-down');
                $productContainer.find('.description-and-detail .details .content')
                    .empty()
                    .html(data.longDescription);
            } else {
                $productContainer.find('.description-and-detail .details')
                    .addClass('hidden-xl-down');
            }
        });
    },

    updateAttribute: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if ($('.product-detail>.bundle-items').length) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
            } else if ($('.product-set-detail').eq(0)) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
            } else {
                $('.product-id').text(response.data.product.id);
                $('.product-detail:not(".bundle-item")').data('pid', response.data.product.id);
            }
        });
    },

    updateAddToCart: function () {
        $('body').on('product:updateAddToCart', function (e, response) {
            // update local add to cart (for sets)
            $('button.add-to-cart', response.$productContainer).attr(
                'disabled',
                (!response.product.readyToOrder || !response.product.available)
            );

            var enable = $('.product-availability').toArray().every(function (item) {
                return $(item).data('available') && $(item).data('ready-to-order');
            });
            module.exports.methods.updateAddToCartEnableDisableOtherElements(!enable);
        });
    },

    updateAvailability: function () {
        $('body').on('product:updateAvailability', function (e, response) {
            $('#js-product-availability-container', response.$productContainer)
                .empty().html(response.message);

            if ($('.global-availability').length) {
                var allAvailable = $('.product-availability').toArray()
                    .every(function (item) {
                        return $(item).data('available');
                    });

                var allReady = $('.product-availability').toArray()
                    .every(function (item) {
                        return $(item).data('ready-to-order');
                    });

                $('.global-availability')
                    .data('ready-to-order', allReady)
                    .data('available', allAvailable);

                $('.global-availability .availability-msg').empty()
                    .html(allReady ? response.message : response.resources.info_selectforstock);
            }
        });

        $(document).on('availability:initPopover', function () {
            initPopOver();
        });
    },

    sizeChart: function () {
        $('.size-chart a').on('click', function (e) {
            e.preventDefault();
            var url = $(this).attr('href');
            var $prodSizeChart = $(this).closest('.size-chart').find('.size-chart-collapsible');
            if ($prodSizeChart.is(':empty')) {
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    success: function (data) {
                        $prodSizeChart.append(data.content);
                    }
                });
            }
            $prodSizeChart.toggleClass('active');
        });

        var $sizeChart = $('.size-chart-collapsible');
        $('body').on('click touchstart', function (e) {
            if ($('.size-chart').has(e.target).length <= 0) {
                $sizeChart.removeClass('active');
            }
        });
    },

    copyProductLink: function () {
        $('body').on('click', '#fa-link', function (event) {
            event.preventDefault();
            var $temp = $('<input>');
            $('body').append($temp);
            $temp.val($('#shareUrl').val()).select();
            document.execCommand('copy');
            $temp.remove();
            $('.copy-link-message').attr('role', 'alert');
            $('.copy-link-message').removeClass('d-none');
            setTimeout(function () {
                $('.copy-link-message').addClass('d-none');
            }, 3000);
        });
    },

    handleSectionSelection: function () {
        $('body').on('click', '.js-section-header-load-content', function () {
            const currentSection = $(this);
            const url = currentSection.data('section-url');
            const pid = currentSection.data('pid');
            const section = currentSection.data('section');
            const selectedPid = currentSection.data('selected-pid') ? currentSection.data('selected-pid') : '';
            const selectedPidPrice = currentSection.data('selected-price') ? currentSection.data('selected-price') : '';
            const sectionViewType = currentSection.data('section-view-type');
            const dataUrl = url + '?pid=' + pid + '&section=' + section + '&selectedPid=' + selectedPid + '&selectedPidPrice=' + selectedPidPrice + '&sectionViewType=' + sectionViewType;

            currentSection.removeClass('js-section-header-load-content');

            const productSelectorInputs = $(this).closest('.js-configurator-section').find('input[type="radio"]');
            updateDeltaLabels(productSelectorInputs, selectedPidPrice);

            $.ajax({
                url: dataUrl,
                type: 'get',
                dataType: 'html',
                success: function (data) {
                    const sectionContent = $(currentSection).siblings('.section-body').find('.section-content');
                    if (!sectionContent.length) {
                        return;
                    }

                    sectionContent.html(data);
                    initPopOver();

                    const swiperSlider = sectionContent.find('.js-configurable-products-slider')[0];
                    if (!swiperSlider) {
                        return;
                    }

                    initSwiperSlider(swiperSlider);
                    const swiperEle = swiperSlider.querySelector('.swiper');

                    if (swiperEle) {
                        triggerLoadMoreOnSwiperSlider(swiperEle);
                    }
                }
            });
        });

        // Display the next page of content results from the search
        $('body').on('click', '.js-more-button', function () {
            getMoreContent($(this), $(this).closest('.section-content'), false);
            $(this).closest('.js-more-button-wrapper').remove();
        });

        document.querySelectorAll('.js-configurable-products-slider .swiper').forEach((swiperEle)=>{
            triggerLoadMoreOnSwiperSlider(swiperEle);
        });
    },

    handleRecommendationSelection: function () {
        $('body').on('click', '.configurator-product input[type="radio"]', function () {
            const currentSection = $(this).closest('.js-configurator-section');
            const currentSelectedProduct = $(this).closest('.configurator-product').data('pid');
            const currentSelectedProductQuantity = $(this).closest('.configurator-product').data('quantity');
            const currentSectionHeader = currentSection.find('.js-section-header');
            const currentHeaderProductName = currentSectionHeader.find('.js-selected-product-name');
            const currentSectionValue = currentSectionHeader.data('section');
            const currentConfiguratorConfig = $('.configurator-sections').data('configurator-config');
            const currentConfiguratorConfigSections = Object.keys(currentConfiguratorConfig);

            if (currentConfiguratorConfigSections.length) {
                if (currentConfiguratorConfigSections.indexOf(currentSectionValue.toString()) === -1) {
                    currentConfiguratorConfig[currentSectionValue] = {};
                }
                if (currentSelectedProduct) {
                    currentConfiguratorConfig[currentSectionValue].pid = currentSelectedProduct.toString();
                    currentConfiguratorConfig[currentSectionValue].qty = currentSelectedProductQuantity;
                } else {
                    delete currentConfiguratorConfig[currentSectionValue];
                }
            } else {
                currentConfiguratorConfig[currentSectionValue] = {};
                currentConfiguratorConfig[currentSectionValue].pid = currentSelectedProduct.toString();
                currentConfiguratorConfig[currentSectionValue].qty = currentSelectedProductQuantity;
            }

            $('.configurator-sections').attr('data-configurator-config', JSON.stringify(currentConfiguratorConfig));

            const currentPageUrl = new URL(window.location.href);
            if (!currentPageUrl.searchParams.get('backfromcart')) {
                setConfiguratorConfigParam(currentPageUrl);
                // eslint-disable-next-line no-restricted-globals
                history.replaceState(null, '', currentPageUrl.toString());
            }

            const selectedProductElement = this.closest('.js-configurator-product');
            const availabilityClasses = $(selectedProductElement).find('.product-availability-message').attr('class');
            currentHeaderProductName.html(`<span class="${availabilityClasses || 'text-body-secondary fw-normal d-block text-xxxl-end'}"><span>${$(this).val()}</span></span>`);
            const isSelectedProductNotbuyable = $(this).data('notbuyable');
            currentSectionHeader.attr('data-notbuyable', isSelectedProductNotbuyable);

            setSelectedPcConfiguratorCases(currentSection, selectedProductElement);

            const productSelectorInputs = currentSection.find('input[type="radio"]');
            const currentSelectedPrice = parseFloat($(this).data('price'));
            $(this).attr('checked', true);

            updateProductPrice(parseFloat($(this).attr('data-raw-delta')));
            updateDeltaLabels(productSelectorInputs, currentSelectedPrice);
            handleSectionNotBuyable();

            const isThisProductInListView = selectedProductElement?.classList.contains('configurator-product--list');
            const selectedImage = currentSection.find('#js-list-selected-image img');
            /* selected product image is updated in the list view */
            if (isThisProductInListView) {
                const imageSrc = selectedProductElement.dataset.productImgUrl;
                if (imageSrc) {
                    selectedImage?.attr('src', imageSrc);
                    selectedImage?.removeClass('d-none');
                } else {
                    selectedImage?.addClass('d-none');
                }
            }
        });
    },

    copyLinkListener: function () {
        const copyLinkButton = document.getElementById('js-configurator-shareLinkModalBtn');
        const configuration = document.querySelector('.js-configurator-sections');
        const $copyLinkModal = $('#shareLinkModal');

        if (copyLinkButton && configuration) {
            copyLinkButton.addEventListener('click', () => {
                try {
                    const currentUrl = configuration.dataset?.currentUrl;
                    const configuratorProductUrl = setConfiguratorConfigParam(new URL(currentUrl)).toString();
                    let message = configuration.getAttribute('data-share-message');
                    const $shareLinkInput = $('#js-share-link-input');
                    $shareLinkInput.val(configuratorProductUrl);
                    $shareLinkInput.data('msg', message);
                    $copyLinkModal.modal('show');
                } catch (e) {
                    console.error(e);
                }
            });
        }

        $('#js-copy-link-btn').bind('click', () => {
            const $shareLinkInput = $('#js-share-link-input');
            $shareLinkInput.select();
            const msg = $shareLinkInput.data('msg');
            document.execCommand('copy');

            $copyLinkModal.modal('hide');
            if (msg) {
                showToastMessage({
                    message: msg,
                    alertType: 'alert-success'
                });
            }
        });
    },

    replaceSectionButtonListener: function () {
        document.body.addEventListener('click', function (event) {
            const btn = event.target.closest('.js-btn-replace-section-product');

            if (btn) {
                const targetSelector = btn.getAttribute('data-scroll-to');
                if (!targetSelector) {
                    return;
                }
                const targetElement = document.querySelector(targetSelector);
                if (!targetElement) {
                    return;
                }

                if (targetElement.classList.contains('collapsed')) {
                    targetElement.click();
                }
            }
        });
    },
    handleConfiguratorNotBuyable: handleConfiguratorNotBuyable,
    handleSectionNotBuyable: handleSectionNotBuyable,
    focusChooseBonusProductModal: base.focusChooseBonusProductModal(),
    handleProductVariationAjaxEvent: function () {
        document.addEventListener('pdp:productVariationAjaxDone', function () {
            handleConfiguratorNotBuyable();
            handleSectionNotBuyable();
        });
    },
    variantImgHover: variantImgHover
};
